import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import styles from './Navigation.module.css';

interface NavigationProps {
  isOpen: boolean;
  onClose: () => void;
}

function Navigation({ isOpen, onClose }: NavigationProps) {
  const [servicesOpen, setServicesOpen] = useState(false);

  const handleLinkClick = () => {
    onClose();
    setServicesOpen(false);
  };

  return (
    <nav className={`${styles.nav} ${isOpen ? styles.open : ''}`}>
      <ul className={styles.menu}>
        <li>
          <NavLink
            to="/main"
            className={({ isActive }) => (isActive ? styles.active : '')}
            onClick={handleLinkClick}
          >
            Main
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/about-us"
            className={({ isActive }) => (isActive ? styles.active : '')}
            onClick={handleLinkClick}
          >
            About Us
          </NavLink>
        </li>
        <li className={styles.dropdown}>
          <button
            className={styles.dropdownToggle}
            onClick={() => setServicesOpen(!servicesOpen)}
            aria-expanded={servicesOpen}
          >
            Services
            <span className={`${styles.arrow} ${servicesOpen ? styles.arrowUp : ''}`}>
              ▼
            </span>
          </button>
          <ul className={`${styles.submenu} ${servicesOpen ? styles.submenuOpen : ''}`}>
            <li>
              <NavLink
                to="/services/seo-tools"
                className={({ isActive }) => (isActive ? styles.active : '')}
                onClick={handleLinkClick}
              >
                SEO Tools
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/services/network-tools"
                className={({ isActive }) => (isActive ? styles.active : '')}
                onClick={handleLinkClick}
              >
                Network Tools
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/services/dev-tools"
                className={({ isActive }) => (isActive ? styles.active : '')}
                onClick={handleLinkClick}
              >
                Dev Tools
              </NavLink>
            </li>
          </ul>
        </li>
        <li>
          <NavLink
            to="/contact-us"
            className={({ isActive }) => (isActive ? styles.active : '')}
            onClick={handleLinkClick}
          >
            Contact Us
          </NavLink>
        </li>
      </ul>
    </nav>
  );
}

export default Navigation;
